import React from 'react';
import { EcoAssociation11Class2025 } from '../views';

const AccountGeneralPages = () => {
  return <EcoAssociation11Class2025/>;
};

export default AccountGeneralPages;